'use strict';
module.exports = window.process.env || {};
